/*
 * @Descripttion: url 链接操作
 * @version: 1.0.0
 * @Author: 陈敏
 * @Date: 2022-07-14 15:02:04
 */

export function getUrlParams(name = '', url = '') {
  url = url || window.location.href;
  name = name.replace(/[[\]]/g, '\\$&');
  let regex = new RegExp('[?&#]' + name + '(=([^&#]*)|&|#|$)');
  let results = regex.exec(url);
  if (!results) {
      return null;
  }
  if (!results[2]) {
      return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function addUrlParams(url = '', params = {}) {
  let hasAddParam = false;
  for (let attr in params) {
      if (typeof params[attr] === 'undefined' || params[attr] === null) {
          continue;
      }
      if (url.match(new RegExp('[&?]' + attr + '='))) {
          continue;
      }
      if (!hasAddParam && url.indexOf('?') < 0) {
          url += '?';
      }
      else {
          url += '&';
      }
      hasAddParam = true;
      if (typeof params[attr] === 'object') {
          url += attr + '=' + encodeURIComponent(JSON.stringify(params[attr]));
      }
      else {
          url += attr + '=' + encodeURIComponent(params[attr] + '');
      }
  }
  return url;
}

export function creatUrlParams(url = '', params = {}) {
  let hasAddParam = false;
  for (let attr in params) {
      if (typeof params[attr] === 'undefined' || params[attr] === null) {
          continue;
      }
      if (url.match(new RegExp('[&?]' + attr + '='))) {
          continue;
      }
      if (!hasAddParam && url.indexOf('?') < 0) {
          url += '?';
      }
      else {
          url += '&';
      }
      hasAddParam = true;
      if (typeof params[attr] === 'object') {
          url += attr + '=' + JSON.stringify(params[attr]);
      }
      else {
          url += attr + '=' + params[attr] + '';
      }
  }
  return url;
}



// WEBPACK FOOTER //
// ./src/utils/url.js